export const scheduleJobFieldStyles = {
  fields: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    paddingBottom: 24
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  fieldLabel: {
    fontSize: 14,
    fontWeight: 400,
    color: '#252e3d',
    lineHeight: '20px'
  },
  dateRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 12
  },
  datePair: {
    flex: 1,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12
  },
  dateButton: {
    position: 'relative',
    height: 38,
    border: '1px solid #d9dee8',
    borderRadius: 4,
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 12,
    overflow: 'hidden',
    '&:hover': {
      borderColor: '#b0b8c6'
    }
  },
  dateButtonText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#252e3d',
    lineHeight: '20px',
    userSelect: 'none',
    pointerEvents: 'none'
  },
  dateButtonPlaceholder: {
    color: '#929fb5'
  },
  hiddenDateInput: {
    position: 'absolute',
    inset: 0,
    opacity: 0,
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    border: 'none',
    padding: 0
  },
  calendarButton: {
    width: 38,
    height: 38,
    flexShrink: 0,
    border: '1px solid #0766ee',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    cursor: 'pointer',
    color: '#0766ee',
    marginBottom: 1,
    '&:hover': {
      backgroundColor: '#f0f6ff'
    }
  },
  selectField: {
    position: 'relative',
    height: 38,
    border: '1px solid #d9dee8',
    borderRadius: 4,
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 13px',
    '&:hover': {
      borderColor: '#b0b8c6'
    }
  },
  selectFieldActive: {
    borderColor: '#0766ee',
    boxShadow: '0 0 0 1px #0766ee'
  },
  selectFieldText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#252e3d',
    lineHeight: '20px'
  },
  selectFieldPlaceholder: {
    color: '#929fb5'
  },
  selectFieldIcon: {
    fontSize: 16,
    color: '#738198',
    flexShrink: 0
  }
} as const
